<img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo">
<div class="iwg-form-dialog" [ngClass]="{'iwg-dialog-half-size':!((step1.selectedQuote && step1.selectedQuote.QuoteRequest_Country_Abbreviation != 'US' || (step1.service_type_id==1 || step1.service_type_id==2 || step1.service_type_id==3)) && (step1.selectedQuote && step1.selectedQuote.QuoteRequest_Title!='') && selectedStepIndex < 4) || (selectedStepIndex >= 3)}">
    <div class="md-toolbar-tools d-flex md-theme m-0 p-3">
        <h2 class="m-0 toolbartitle">
            {{WizardTitle}}
        </h2>
        <span class="flex"></span>
        <span *ngIf="selectedStepIndex < 3">Step {{selectedStepIndex + 1}} of {{numberOfSteps}}</span>
        <span *ngIf="selectedStepIndex >= 3">Review & Submit</span>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <mat-dialog-content style="overflow: hidden;padding:0px;display: table;width: 100%;">
        <div class="vista-popup-height">
        <div class="d-flex layout-row" style="height: 100%;">
            <div class="d-flex layout-column flex md-padding w-100"
             style="height:100%;overflow-y: scroll;box-sizing: border-box;padding: 16px;"
             >
                <mat-tab-group [(selectedIndex)]="selectedStepIndex" class="header-less-tabs">
                    <mat-tab label="Step 1">
                        <form name="assignmentStep1" #assignmentStep1="ngForm">

                            <h3 class="mat-header">{{AssignmentLabel}} Setup</h3>
                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Quote</mat-label>
                                    <mat-select name="quote" #quote="ngModel" [(ngModel)]="step1.selectedQuoteSimple"
                                        [required]="!preselectedQuoteId"
                                        [disabled]="isTransfer()"
                                        (selectionChange)="onselectedQuoteChange($event)">
                                        <mat-option *ngFor="let item of quotesSimple" [value]="item">{{item.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-icon [matTooltip]="AssignmentLabel+'s must be based on active quotes. Please select the applicable quote. If you do not have one for this '
                                +AssignmentLabel+', please select Get a Quote from your dashboard.'"
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                                <mat-error *ngIf="!quote.valid && quote.touched">Required</mat-error>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>{{AssignmentLabel}} Title</mat-label>
                                    <input matInput name="title" [(ngModel)]="step1.title" #Ctitle="ngModel" name="title" maxlength="200" required>
                                </mat-form-field>
                                <mat-icon matTooltip="Provide a title with enough context to help you track it." 
                                matTooltipPosition="above"
                                class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                <mat-error *ngIf="!Ctitle.valid && Ctitle.touched">Required</mat-error>
                            </div>

                            <h3 *ngIf="allowEndClients" class="mat-header">End Client</h3>
                            <app-end-client-select
                            name="endclients"
                            [(ngModel)]="step1.selectedEndClient"
                            [preselected-item-id]="step1.selectedEndClient?step1.selectedEndClient.ID:null"
                            [refresh-on-preselect]="true"
                            *ngIf="allowEndClients"
                            ></app-end-client-select>

                            <app-add-end-clients
                            [new-item-id]="step1.selectedEndClient?step1.selectedEndClient.ID:null"
                            *ngIf="allowEndClients"
                            ></app-add-end-clients>

                            <div class="md-input-container" fxLayout="row"
                            *ngIf="step1.service_type_id ==1 && !US_EOR"
                             fxLayoutAlign="start ">

                                <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                    <mat-label>Business Entity in Country</mat-label>
                                    <mat-radio-group required #is_entity_in_country="ngModel" [(ngModel)]="step1.is_entity_in_country" class="d-block"
                                        name="business_incountry" [disabled]="true" aria-label="Select an option">
                                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error *ngIf="!is_entity_in_country.valid && is_entity_in_country.touched">Required</mat-error>
                                </div>
                                <div fxFlexAlign="baseline">
                                    <mat-icon
                                        matTooltip="Has your company established a business entity in this country? This may impact pricing and services."
                                        class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                </div>

                            </div>

                            
                            <app-manager-select name="managerSel" [preselected-item-id]="step1.selectedManager?.ID"
                                                    [required]="true" [(ngModel)]="step1.selectedManager"
                                    [refresh-on-preselect]="true">
                                </app-manager-select>
                            <app-add-manangers (added)="step1.selectedManager = $event"
                                [new-item-id]="step1.selectedManager?step1.selectedManager.ID:null">
                            </app-add-manangers>

                           
                            <app-worker-select name="WorkerSel" [(ngModel)]="step1.selectedWorker"
                                    [filter-item-id-NOT]="Filter_ClientID" [preselected-item-id]="step1.selectedWorker?.ID"
                                    [refresh-on-preselect]="true" [service-type-id]="step1.service_type_id"
                                                [is-required]="true" [disabled]="isTransfer()"
                                    *ngIf="Ready" required></app-worker-select>
                            
                            <div style="width: 90%">
                                <app-country-select name="CountrySel" 
                                [(ngModel)]="step1.selectedCountry"
                                [required]="true"
                                [isDisabled]="true"
                                [idOnly]="false"
                                [preselectedItemId]="step1.selectedCountry?step1.selectedCountry.ID:null"
                                [alltext]="'Please Select'" [showAll]="true">
                                    
                                </app-country-select>
                                <mat-icon matTooltip="Please select the country of citizenship for the worker." 
                                matTooltipPosition="above"
                                class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                           
                            <app-team-select
                            *ngIf="allowTeams"
                            name="stepoTeamSel"
                            [(ngModel)]="step1.selectedTeam"
                            [preselected-item-id]="step1.selectedTeam?step1.selectedTeam.ID:null"
                            [filter-item-id-NOT]="Filter_ClientID"
                            ></app-team-select>

                            <h3 class="mat-header mt-3" *ngIf="ShowComplianceRegions">Select Region</h3>
                            <app-state-select
                            name="stepoState"
                            required
                            [(ngModel)]="step1.selectedStateCompliance"
                            [preselected-item-id]="step1.selectedStateCompliance?step1.selectedStateCompliance.ID:null"
                            [country-id]="step1.selectedCountry?step1.selectedCountry.ID:null"
                            [alltext]="'Please Select'"
                            *ngIf="ShowComplianceRegions"
                            ></app-state-select>

                        </form>
                    </mat-tab>
                    <mat-tab label="Step 2">
                        <form name="assignmentStep2" #assignmentStep2="ngForm">
                            <h3>{{(step1.service_type_id == 2 || step1.service_type_id == 3) ? 'Project Information' : 'Role and Date Details' }}</h3>
                            <div class="d-flex">
                                <div class="md-input-container vista-datespace">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Start Date</mat-label>
                                        <input name="start_date" #start_date="ngModel" [(ngModel)]="step2.start_date"
                                            [max]="step2.estimated_end_date" placeholder="Select" matInput
                                            [matDatepicker]="picker" required>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-icon matTooltip="Please specify the date on which the engagement will start."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                    </mat-icon>
                                    <mat-error *ngIf="!start_date.valid && start_date.touched">Required</mat-error>
                                </div>

                                <div class="md-input-container vista-datespace">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Estimated End Date</mat-label>
                                        <input [min]="step2.start_date" [required]="US_EOR" name="estimated_end_date"
                                            [(ngModel)]="step2.estimated_end_date" placeholder="Select" matInput
                                            [matDatepicker]="edpicker">
                                        <mat-datepicker-toggle matSuffix [for]="edpicker"></mat-datepicker-toggle>
                                        <mat-datepicker #edpicker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-icon
                                        [matTooltip]="US_EOR?'An actual or estimated end date is required.':'Please specify the estimated date on which this engagement will end.'"
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                    </mat-icon>
                                </div>
                            </div>

                            <div class="md-input-container" *ngIf="step1.service_type_id ==1">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Notice Time</mat-label>
                                    <input matInput [(ngModel)]="step2.time_for_notice" name="time_for_notice"
                                        maxlength="250">
                                </mat-form-field>
                                <mat-icon
                                    matTooltip="If currenthly employed, how much time for notice does the worker need to provide to current employer?"
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <div class="md-input-container"
                            *ngIf="step2.is_track_spend_allowed == true"
                            >
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Maximum Spend</mat-label>
                                    <input matInput [(ngModel)]="step2.maximum_spend" name="maximum_spend" type="number"
                                        maxlength="250">
                                </mat-form-field>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Department</mat-label>
                                    <input matInput [(ngModel)]="step2.department" name="department" maxlength="250">
                                </mat-form-field>
                                <mat-icon
                                    [matTooltip]="'If your company tracks '+AssignmentLabelLC+'s by department, please provide that department designation here.'"
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Cost Center</mat-label>
                                    <input matInput [(ngModel)]="step2.cost_center" name="cost_center" maxlength="250">
                                </mat-form-field>
                                <mat-icon
                                    [matTooltip]="'If your company tracks '+AssignmentLabelLC+'s by cost center, please provide that cost center designation here.'"
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <div class="md-input-container"  *ngIf="step2.is_sow_allowed == true">
                                <mat-label>Statement of Work</mat-label>
                                <mat-icon
                                    matTooltip=" If you have a statement of work govering this engagement, please upload a copy of that document. We support documents of the following format: doc, docx, pdf, txt, rtf, and eml."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <app-file-upload [upload-url]="'/Api/Assignments/'+existingAssignmentId"
                                *ngIf="step2.is_sow_allowed == true"
                                [file-property]="'sow_file'" [uploaded-file-name]="step2.sowFileName"></app-file-upload>

                            <div class="md-input-container"  *ngIf="step1.service_type_id ==1 && !US_EOR">
                                <mat-label>Offer Letter Sent to Worker &mdash; If Yes, Upload Below</mat-label>
                                <mat-radio-group [(ngModel)]="step2.is_offer_letter_sent" class="d-block"
                                    name="offer_letter" aria-label="Select an option" required>
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon
                                    matTooltip="If your company has provided an offer letter to the worker, please select Yes and upload a copy of that document. We support documents of the following format: doc, docx, pdf, txt, rtf, and eml."
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <app-file-upload [upload-url]="'/Api/Assignments/'+existingAssignmentId"
                                *ngIf="step2.is_offer_letter_sent && step1.service_type_id ==1 && !US_EOR"
                                [file-property]="'offer_letter_file'" [uploaded-file-name]="step2.offerLetterFileName">
                            </app-file-upload>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>{{JobTitleLabel}}</mat-label>
                                    <input matInput [(ngModel)]="step2.job_title" 
                                    name="job_title" maxlength="200" required>
                                </mat-form-field>
                                <mat-icon
                                    matTooltip="Please provide a {{JobTitleLabelLC}} that reflects the specific duties. Examples: Sales for Paris, Lead Software Enginner, Admin to CEO, etc."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <h3 *ngIf="step1.service_type_id ==1" class="mat-header mt-3">Upload Job Description or Enter Text</h3>
                            <div class="md-input-container"  *ngIf="step1.service_type_id ==1" >
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Job Description</mat-label>
                                    <textarea matInput [(ngModel)]="step2.job_description"
                                    required name="job_description"
                                        rows="5"></textarea>
                                </mat-form-field>
                                <mat-icon
                                    matTooltip="A complete job description is necessary to engage the worker. If you have a job description as a document, please upload it, below. We support job description documents of the following format: doc, docx, pdf, txt, and rtf."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <h3 class="mat-header mt-3"
                            *ngIf="step1.service_type_id ==3 || step1.service_type_id ==2"
                            >Upload Project Description or Enter Text</h3>
                            <div class="md-input-container" *ngIf="step1.service_type_id ==3 || step1.service_type_id ==2">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Project Description</mat-label>
                                    <textarea #project_description="ngModel" matInput [(ngModel)]="step2.job_description"
                                     name="project_description" [required]="jobDescriptionRequired"
                                        rows="5"></textarea>
                                </mat-form-field>
                                <mat-icon
                                    matTooltip="A complete project description is necessary to engage the contractor. If you have a project description as a document, please upload it, below. We support project description documents of the following format: doc, docx, pdf, txt, and rtf."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                                <mat-error *ngIf="!project_description.valid && project_description.touched">Required</mat-error>
                            </div>                            

                            <app-file-upload upload-url="/Api/Assignments/{{existingAssignmentId}}"
                                file-property="job_description_file"
                                uploaded-file-name="{{step2.jobDescriptionFileName}}"></app-file-upload>

                        </form>
                    </mat-tab>
                    <mat-tab label="Step 3">
                        <form name="assignmentStep3" #assignmentStep3="ngForm">
                            <h3>{{(step1.service_type_id == 2 || step1.service_type_id == 3) ? 'Project Amount' : 'Compensation' }}</h3>
                            <p class="iwg-help-box">
                                <span flex>Pay</span>
                                <mat-icon
                                            style="vertical-align: middle;margin-left: 2px"
                                        matTooltip="What is the total spend for this project?. Please specify the Total Project Amount and Currency for this Engagement."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                            </p>
                            <div layout="row" *ngIf="step1.service_type_id==3 || step1.service_type_id==2">
                                <div style="display: flex;"
                                    fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" >
                                    <div flex fxFlex="50">
                                        <mat-form-field class="mat-form-withtooltip" *ngIf="US_EOR">
                                            <mat-label>{{PayAmountTitle}}*</mat-label>
                                            <input matInput type="number" [min]="0.01"
                                                   #pay_rates="ngModel" required name="pay_rate"
                                                    [(ngModel)]="step3.pay_rate" [disabled]="isTransfer()"
                                                   maxlength="250">
                                            <mat-error *ngIf="!pay_rates.valid && pay_rates.touched">Required</mat-error>
                                        </mat-form-field>
                                        <mat-form-field class="mat-form-withtooltip" *ngIf="!US_EOR">
                                        <mat-label>{{PayAmountTitle}}*</mat-label>
                                        <input matInput type="number" [min]="0.01" required name="pay_rate"
                                            [(ngModel)]="step3.pay_rate" 
                                               #pay_rates1="ngModel" [disabled]="isTransfer()"
                                            maxlength="250">
                                            <mat-error *ngIf="!pay_rates1.valid && pay_rates1.touched">Required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div flex fxFlex="50">
                                    <app-currency-select [(ngModel)]="step3.selectedCurrency" [helptext]=""
                                        name="currencysel" [required]="true" [is-disabled]="isTransfer()"
                                        [preselected-item-id]="step3.selectedCurrency?.ID">
                                    </app-currency-select>
                                </div>
                                </div>
                            </div>
                            <div layout="row" *ngIf="(step1.service_type_id==3 || step1.service_type_id==2)">
                                <app-pay-rate-select iscompliance="true" 
                                    *ngIf="IsCompliance || step1.service_type_id==2"
                                    name="payRateTypeStructureSel"
                                    label="Pay Structure"
                                    [disabled]="isTransfer()"
                                    [(ngModel)]="step3.selectedPayRateTypeStructure"
                                    [preselected-item-id]="step3.selectedPayRateTypeStructure?step3.selectedPayRateTypeStructure.ID:null">
                                </app-pay-rate-select>
                            </div>

                            <div class="md-input-container" *ngIf="US_EOR">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Hours Per Week</mat-label>
                                    <input matInput [(ngModel)]="step3.hours_per_week" name="hours_per_week"
                                        type="number" [min]="0.01">
                                </mat-form-field>
                                <mat-icon
                                    matTooltip="Please provide the expected average number of workers to be worked per week."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <div class="md-input-container" *ngIf="US_EOR">
                                <mat-label>Full-time or Part-time</mat-label>
                                <mat-radio-group [(ngModel)]="step3.fulltime" required class="d-block" name="offer_letter"
                                    aria-label="Select an option">
                                    <mat-radio-button [value]="true">Full-time</mat-radio-button>
                                    <mat-radio-button [value]="false">Part-time</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon
                                    matTooltip="A full-time employee is, for a calendar month, an employee who works an average of at least 30 hours per week. A part-time employee is, for a calendar month, an employee who works an average of less than 30 hours per week."
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <div class="md-input-container" *ngIf="US_EOR">
                                <mat-label>Regular or Sporadic</mat-label>
                                <mat-radio-group [(ngModel)]="step3.regular" required class="d-block" name="offer_letter"
                                    aria-label="Select an option">
                                    <mat-radio-button [value]="true">Regular</mat-radio-button>
                                    <mat-radio-button [value]="false">Required</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon
                                    matTooltip="A regular employee works on a usual and consistent basis. A sporadic employee works on an infrequent, irregular, or occurring in scattered instances and not on a regular weekly schedule."
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <div class="md-input-container"  *ngIf="US_EOR">
                                <mat-label>Exempt or Non-Exempt</mat-label>
                                <mat-radio-group [(ngModel)]="step3.exempt" class="d-block" name="offer_letter"
                                    aria-label="Select an option">
                                    <mat-radio-button [value]="true">Exempt</mat-radio-button>
                                    <mat-radio-button [value]="false">Non-Exempt</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon
                                    matTooltip="Non-exempt employees are entitled to overtime pay under the Fair Labor Standards Act (FLSA). Because of their positional duties, responsibilities, and level of decision-making authority, exempt employees are exempt from the overtime provisions of the Fair Labor Standards Act (FLSA). Whether an employee is exempt or nonexempt depends on how much the employee is paid, how the employee is paid, and the nature and responsibilities. iWorkGlobal will review and confirm if the position should be classified as exempt or non-exempt."
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>
                                        {{(step1.service_type_id == 2 || step1.service_type_id == 3) ? 'Additional Notes' : 'Compensation Details &mdash; Bonuses, Commissions, Etc.' }}
                                    </mat-label>
                                    <textarea matInput [(ngModel)]="step3.other_compensation" name="other_compensation"
                                        rows="5"></textarea>
                                </mat-form-field>
                            </div>
                        </form>
                    </mat-tab>
                    <mat-tab label="Step 4" *ngIf="step1.service_type_id ==1">
                        <form name="assignmentStep4" #assignmentStep4="ngForm">
                            <h3 *ngIf="step1.service_type_id ==1">Authorization and Requirements</h3>
                            <h3 *ngIf="step1.service_type_id ==2 || step1.service_type_id ==3">Workplace</h3>

                            <div class="md-input-container" *ngIf="step1.service_type_id ==1">
                                <mat-label>Travel Required</mat-label>
                                <mat-radio-group [(ngModel)]="step4.is_travel_required" class="d-block"
                                    name="offer_letter" aria-label="Select an option">
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon matTooltip="Will the worker be expected to travel as part of this engagement?"
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <div class="md-input-container"  *ngIf="step4.is_travel_required">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Please List Travel Locations:</mat-label>
                                    <textarea matInput [(ngModel)]="step4.travel_locations" name="travel_locations"
                                        rows="1" required></textarea>
                                    <mat-icon
                                        matTooltip="Please provide a list of the travel locations for the worker for this {{AssignmentLabelLC}}."
                                        class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="md-input-container"  *ngIf="step1.service_type_id ==1">
                                <mat-label>Driving Required</mat-label>
                                <mat-radio-group [(ngModel)]="step4.is_driving_required" class="d-block"
                                    name="offer_letter" aria-label="Select an option">
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon matTooltip="Will the worker be expected to travel as part of this engagement?"
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <div class="md-input-container" *ngIf="step1.service_type_id ==1">
                                <mat-label>Equipment Provided &mdash; If Yes, Please Provide Details</mat-label>
                                <mat-radio-group [(ngModel)]="step4.is_equipment_provided" class="d-block"
                                    name="offer_letter" aria-label="Select an option">
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon matTooltip="Will equipment be provided to worker?"
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <div class="md-input-container" *ngIf="step4.is_equipment_provided">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Please List Equipment:</mat-label>
                                    <textarea matInput [(ngModel)]="step4.equipment_provided" name="travel_locations"
                                        rows="1" required></textarea>
                                    <mat-icon
                                        matTooltip="Please provide a list of the equipment that will be provided to the worker for this {{AssignmentLabelLC}}. This will typically include items such as cellphones, computers, etc."
                                        class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                </mat-form-field>
                            </div>

                            <div class="md-input-container" *ngIf="step1.service_type_id ==1">
                                <mat-label>Working Offsite</mat-label>
                                <mat-radio-group [(ngModel)]="step4.is_working_from_home" class="d-block"
                                    name="offer_letter" aria-label="Select an option">
                                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                </mat-radio-group>
                                <mat-icon
                                    matTooltip="Do you authorize the worker to work offsite (home, etc.) as part of this engagement?"
                                    class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                            </div>

                            <h3 class="mat-header mt-3">Worksite Address</h3>
                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Street 1</mat-label>
                                    <input matInput [(ngModel)]="step4.worksite_street1" name="worksite_street1">
                                </mat-form-field>
                                <mat-icon
                                    matTooltip="Please provide the address for where the worker will be providing services to your company."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
                                </mat-icon>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Street 2</mat-label>
                                    <input matInput [(ngModel)]="step4.worksite_street2" name="worksite_street2">
                                </mat-form-field>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>City</mat-label>
                                    <input matInput [(ngModel)]="step4.worksite_city" name="worksite_city">
                                </mat-form-field>
                            </div>

                            <div class="md-input-container">
                                <mat-form-field class="mat-form-withtooltip">
                                    <mat-label>Postal Code</mat-label>
                                    <input matInput [(ngModel)]="step4.worksite_postal_code"
                                        name="worksite_postal_code">
                                </mat-form-field>
                            </div>

                            <app-country-select name="worker_scountry" 
                            [disabled]="true" [alltext]="'Please Select'">
                            </app-country-select>

                            <app-state-select
                            name="stepFstate"
                            [(ngModel)]="step4.selectedState"
                            [preselected-item-id]="step4.selectedState?step4.selectedState.ID:null"
                            [country-id]="step4.selectedCountry?step4.selectedCountry.ID:null"
                            [isDisabled]="false"
                            ></app-state-select>

                        </form>
                    </mat-tab>
                    <mat-tab label="review">
                            <h3>Review {{AssignmentLabel}} Details</h3>
                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 1: {{AssignmentLabel}} Setup</span><span flex></span><a (click)="selectedStepIndex=0" class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Quote Title</label>
                                    <p class="iwg-regular-value">{{step1.selectedQuote?step1.selectedQuote.QuoteRequest_Title:''}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">{{AssignmentLabel}} Title</label>
                                    <p class="iwg-regular-value">{{step1.title}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="allowEndClients">
                                    <label class="iwg-regular-label">End Client</label>
                                    <p class="iwg-regular-value">{{step1.selectedEndClient?step1.selectedEndClient.Name:null}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Business Entity in Country</label>
                                    <p class="iwg-regular-value">{{step1.is_entity_in_country | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Manager</label>
                                    <p class="iwg-regular-value">{{step1.selectedManager?step1.selectedManager.Name:null}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">{{WorkerLabel}}</label>
                                    <p class="iwg-regular-value">{{step1.selectedWorker?step1.selectedWorker.Name:null}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==3 || step1.service_type_id ==2">
                                    <label class="iwg-regular-label">Business Name</label>
                                    <p class="iwg-regular-value">{{step1.selectedWorker?step1.selectedWorker.CompanyName:null}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Country of Citizenship</label>
                                    <p class="iwg-regular-value">{{step1.selectedCountry?step1.selectedCountry.Name:''}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="allowTeams">
                                    <label class="iwg-regular-label">Team</label>
                                    <p class="iwg-regular-value">{{step1.selectedTeam?step1.selectedTeam.Name:''}}</p>
                                </div>
                                <div *ngIf="step1.selectedStateCompliance && IsCompliance" class="iwg-widget-box-card">
                                    <label class="iwg-regular-label" *ngIf="(step1.selectedCountry?step1.selectedCountry.Name:null) != 'USA'">Region</label>
                                    <label class="iwg-regular-label" *ngIf="(step1.selectedCountry?step1.selectedCountry.Name:null) == 'USA'">State</label>
                                    <p class="iwg-regular-value">{{step1.selectedStateCompliance.Name}}</p>
                                </div>
                            </div>

                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">{{(step1.service_type_id == 2 || step1.service_type_id == 3) ? 'Step 2: Project Information' : 'Step 2: Role Details' }}</span><span flex></span>
                                    <a
                                       (click)="selectedStepIndex=1" class="iwg-review-bar-edit">Edit</a>
                                </div>

                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Start Date</label>
                                    <p class="iwg-regular-value">{{step2.start_date | date}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Estimated End Date</label>
                                    <p class="iwg-regular-value">{{step2.estimated_end_date | date}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Notice Time</label>
                                    <p class="iwg-regular-value">{{step2.time_for_notice}}</p>
                                </div>

                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Department</label>
                                    <p class="iwg-regular-value">{{step2.department}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Cost Center</label>
                                    <p class="iwg-regular-value">{{step2.cost_center}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Offer Letter Sent to Worker</label>
                                    <p class="iwg-regular-value">{{step2.is_offer_letter_sent | yesNo}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step2.is_track_spend_allowed== true">
                                    <label class="iwg-regular-label">Maximum Spend</label>
                                    <p class="iwg-regular-value">{{step2.maximum_spend | blank}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step2.is_sow_allowed== true">
                                    <label class="iwg-regular-label">Statement Of Work</label>
                                    <p class="iwg-regular-value" style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{step2.sow_file | blank}}
                                        <button class="mat-icon-button"
                                        (click)="downloadSOWFile()"
                                        *ngIf="step2.sow_file"
                                         [disabled]="isLoading"><mat-icon>file_upload</mat-icon></button>
                                    </p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Offer Letter File</label>
                                    <p class="iwg-regular-value" style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{step2.offer_letter_file | blank}}
                                        <button class="mat-icon-button"
                                        (click)="downloadOfferLetterFile()"
                                        *ngIf="step2.offer_letter_file"
                                         [disabled]="isLoading"><mat-icon>file_upload</mat-icon></button>
                                    </p>
                                </div>

                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">{{JobTitleLabel}}</label>
                                    <p class="iwg-regular-value">{{step2.job_title}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Job Description</label>
                                    <pre style="font-size: 14px;color: #333;margin: 0;white-space: pre-line;font-family: Lato,Helvetica Neue,sans-serif;">{{step2.job_description | blank}}</pre>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Job Description File</label>
                                    <p class="iwg-regular-value" style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{step2.job_description_file | blank}}
                                        <button class="mat-icon-button"
                                        (click)="downloadJobDescriptionFile()"
                                        *ngIf="step2.job_description_file"
                                         [disabled]="isLoading"><mat-icon>file_upload</mat-icon></button>
                                    </p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="(step1.service_type_id == 2 || step1.service_type_id == 3)">
                                    <label class="iwg-regular-label">Project Description</label>
                                    <pre style="font-size: 14px;color: #333;margin: 0;white-space: pre-line;font-family: Lato,Helvetica Neue,sans-serif;">{{step2.job_description | blank}}</pre>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="(step1.service_type_id == 2 || step1.service_type_id == 3)">
                                    <label class="iwg-regular-label">Project Description File</label>
                                    <p class="iwg-regular-value" style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{step2.job_description_file | blank}}
                                        <button class="mat-icon-button"
                                        (click)="downloadJobDescriptionFile()"
                                        *ngIf="step2.job_description_file"
                                         [disabled]="isLoading"><mat-icon>file_download</mat-icon></button>
                                    </p>
                                </div>

                            </div>

                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">{{(step1.service_type_id == 2 || step1.service_type_id == 3) ? 'Step 3: Project Amount' : 'Step 3: Compensation' }}</span><span flex></span>
                                    <a
                                       (click)="selectedStepIndex=2" class="iwg-review-bar-edit">Edit</a>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id!=3 && step1.service_type_id!=2">
                                    <label class="iwg-regular-label">Pay Rate</label>
                                    <p class="iwg-regular-value">
                                        {{step3.selectedCurrency?step3.selectedCurrency.Symbol:null}}{{step3.pay_rate | number : '.2'}} {{step3.selectedCurrency?step3.selectedCurrency.Abbreviation:null}} / {{step3.selectedPayRateType.Name}}
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="(step1.service_type_id==3 || step1.service_type_id==2) && step3.pay_rate!=0 && step3.pay_rate!=null">
                                    <label class="iwg-regular-label">Total Project Amount</label>
                                    <p class="iwg-regular-value">
                                        {{step3.selectedCurrency?step3.selectedCurrency.Symbol:null}}{{step3.pay_rate | number : '.2'}} {{step3.selectedCurrency?step3.selectedCurrency.Abbreviation:null}}
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="(step1.service_type_id==3 || step1.service_type_id ==2) && step3.selectedPayRateTypeStructure!=null">
                                    <label class="iwg-regular-label">Pay Structure</label>
                                    <p class="iwg-regular-value">
                                        {{step3.selectedPayRateTypeStructure ? step3.selectedPayRateTypeStructure.Name : '' | blank}}
                                    </p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="US_EOR && step1.service_type_id==1">
                                    <label class="iwg-regular-label">Hours Per Week</label>
                                    <p class="iwg-regular-value">{{step3.hours_per_week}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="US_EOR && step1.service_type_id==1">
                                    <label class="iwg-regular-label">Fulltime</label>
                                    <p class="iwg-regular-value">{{step3.fulltime | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="US_EOR && step1.service_type_id==1">
                                    <label class="iwg-regular-label">Regular</label>
                                    <p class="iwg-regular-value">{{step3.regular | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="US_EOR && step1.service_type_id==1">
                                    <label class="iwg-regular-label">Exempt</label>
                                    <p class="iwg-regular-value">{{step3.exempt | yesNo}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id==1">
                                    <label class="iwg-regular-label">Overtime Authorized</label>
                                    <p class="iwg-regular-value">{{step3.is_overtime_authorized | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id==1">
                                    <label class="iwg-regular-label">Expense Reimbursement Authorized</label>
                                    <p class="iwg-regular-value">{{step3.is_expenses_authorized | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id==1">
                                    <label class="iwg-regular-label">Commissions Authorized</label>
                                    <p class="iwg-regular-value">{{step3.is_commission_authorized | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id==1">
                                    <label class="iwg-regular-label">Bonuses Authorized</label>
                                    <p class="iwg-regular-value">{{step3.is_bonus_authorized | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">{{(step1.service_type_id == 2 || step1.service_type_id == 3) ? 'Additional Notes' : 'Additional Compensation' }}</label>
                                    <p class="iwg-regular-value">{{step3.other_compensation }}</p>
                                </div>
                            </div>
                            <div *ngIf="step1.service_type_id==1">
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title" *ngIf="step1.service_type_id ==1">Step 4: Authorization and Requirements</span>
                                    <span class="iwg-review-bar-title" *ngIf="step1.service_type_id ==2 || step1.service_type_id ==3">Step 4: Workplace</span>
                                    <span flex></span>
                                    <a
                                       (click)="selectedStepIndex=3" class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Travel Required</label>
                                    <p class="iwg-regular-value">{{step4.is_travel_required | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1 && step4.is_travel_required == true">
                                    <label class="iwg-regular-label">Travel Locations</label>
                                    <p class="iwg-regular-value">{{step4.travel_locations}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Driving Required</label>
                                    <p class="iwg-regular-value">{{step4.is_driving_required | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Equipment Provided</label>
                                    <p class="iwg-regular-value">{{step4.is_equipment_provided | yesNo}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1 && step4.is_equipment_provided">
                                    <label class="iwg-regular-label">Equipment List</label>
                                    <p class="iwg-regular-value">{{step4.equipment_provided}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id ==1">
                                    <label class="iwg-regular-label">Working Offsite</label>
                                    <p class="iwg-regular-value">{{step4.is_working_from_home | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Worksite Address</label>
                                    <p class="iwg-regular-value">{{step4.worksite_street1}}</p>
                                    <p class="iwg-regular-value">{{step4.worksite_street2}}</p>
                                    <p class="iwg-regular-value">{{step4.worksite_city}}</p>
                                    <p class="iwg-regular-value">{{step4.worksite_postal_code}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Country</label>
                                    <p class="iwg-regular-value">{{step4.selectedCountry?step4.selectedCountry.Name:''}}</p>
                                </div>
                                <div *ngIf="step4.selectedState" class="iwg-widget-box-card">
                                    <label class="iwg-regular-label" *ngIf="!US_EOR">Region</label>
                                    <label class="iwg-regular-label" *ngIf="US_EOR">State</label>
                                    <p class="iwg-regular-value">{{step4.selectedState.Name}}</p>
                                </div>
                            </div>
                    </mat-tab>

                </mat-tab-group>
            </div>
            <div *ngIf="((step1.selectedQuote && step1.selectedQuote.QuoteRequest_Country_Abbreviation != 'US' || (step1.service_type_id==1 || step1.service_type_id==2 || step1.service_type_id==3)) && (step1.selectedQuote && step1.selectedQuote.QuoteRequest_Title!='') && selectedStepIndex < 4) && (selectedStepIndex < 3)" 
                class="d-flex layout-column flex md-padding w-100 mobile-hide"
                style="overflow: auto;">
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Quote Title</label>
                    <p class="iwg-regular-value">{{step1.selectedQuote?step1.selectedQuote.QuoteRequest_Title:''}}</p>
                </div>
                <div class="iwg-widget-box-card" *ngIf="allowEndClients">
                    <label class="iwg-regular-label">End Client</label>
                    <p class="iwg-regular-value">{{step1.selectedEndClient?step1.selectedEndClient.Name:'' | blank}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Service</label>
                    <p class="iwg-regular-value">{{step1.selectedQuote.QuoteRequest_Service_Name}}</p>
                </div>
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">Location</label>
                    <p class="iwg-regular-value">{{step1.selectedQuote.QuoteRequest_Country_Name}}<span *ngIf="step1.selectedStateCompliance!=null"> - {{step1.selectedStateCompliance?.Name}}</span></p>
                </div>
              
                <div class="iwg-widget-box-card">
                    <label class="iwg-regular-label">{{AssignmentLabel}} Title</label>
                    <p class="iwg-regular-value">{{step1.title}}</p>
                </div>
               
                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id!=3 && step1.service_type_id!=2">

                    <label class="iwg-regular-label">Weekly Hours</label>

                    <p class="iwg-regular-value">{{step3.hours_per_week}}</p>
                </div>
               
                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id!=3 && step1.service_type_id!=2">
                    <label class="iwg-regular-label">Pay Rate</label>
                    <p class="iwg-regular-value">
                        {{step3.pay_rate | currency}}
                        {{step1.selectedQuote.QuoteRequest_PayCurrency_Abbreviation}} Per {{step3.selectedPayRateType.Name}}
                    </p>
                </div>
                <div class="iwg-widget-box-card" *ngIf="(step1.service_type_id==3 || step1.service_type_id==2) && step3.pay_rate!= 0 && step3.pay_rate!=null">
                    <label class="iwg-regular-label">Total Project Amount</label>
                    <p class="iwg-regular-value">
                        {{step3.selectedCurrency.Symbol}}{{step3.pay_rate | number : '.2'}} {{step3.selectedCurrency.Abbreviation}}
                    </p>
                </div>
                <div class="iwg-widget-box-card" *ngIf="(step1.service_type_id==3 || step1.service_type_id==2) && step3.selectedPayRateTypeStructure!=null">
                    <label class="iwg-regular-label">Pay Structure</label>
                    <p class="iwg-regular-value">
                        {{step3.selectedPayRateTypeStructure?step3.selectedPayRateTypeStructure.Name:'' | blank}}
                    </p>
                </div>
               
                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id!=3 && step1.service_type_id!=2">
                    <label class="iwg-regular-label">Travel Required?
                    </label>
                    <p class="iwg-regular-value">{{step1.selectedQuote.QuoteRequest_EngagementIncludesTravel  | yesNoBlank }}</p>
                </div>
                <div *ngIf="step1.selectedWorker" class="iwg-widget-box-card">
                    <label class="iwg-regular-label">{{WorkerLabel}}</label>
                    <p class="iwg-regular-value">{{step1.selectedWorker.Name}}</p>
                </div>
                <div class="iwg-widget-box-card" *ngIf="step1.selectedWorker && (step1.service_type_id==3 || step1.service_type_id==2)">
                    <label class="iwg-regular-label">Business Name</label>
                    <p class="iwg-regular-value">{{step1.selectedWorker.CompanyName}}</p>
                </div>
            </div>
        </div>
    </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="justify-fend">

    <div [ngClass]="{'mobile-space-btn':((step1.selectedQuote && step1.selectedQuote.QuoteRequest_Country_Abbreviation != 'US' || (step1.service_type_id==1 || step1.service_type_id==2 || step1.service_type_id==3)) && (step1.selectedQuote && step1.selectedQuote.QuoteRequest_Title!='') && selectedStepIndex < 4) && (selectedStepIndex < 3)}">
        <button class="back-btn-vista" mat-button [disabled]="isFileUploadInProgress" *ngIf="selectedStepIndex != 0" (click)="prevStep()">« Back</button>
        <button mat-button [disabled]="isFileUploadInProgress" *ngIf="selectedStepIndex != 3 && selectedStepIndex != 0" (click)="cancel(true)">Save As Draft</button>
        <button mat-button mat-dialog-close *ngIf="selectedStepIndex == 0" (click)="cancel(false)">Cancel</button>
        <button mat-button class="vista-dialogbtn"
        [disabled]="pageLoaded && (!canProceed() || isFileUploadInProgress)"
        *ngIf="!((step1.service_type_id ==1 && selectedStepIndex == 3) || (step1.service_type_id ==2 && selectedStepIndex == 3) || (step1.service_type_id ==3 && selectedStepIndex == 3)) "
         (click)="nextStep()">Save & Continue</button>
         <button mat-button [disabled]="isFileUploadInProgress"
          *ngIf="!((step1.service_type_id ==1 && selectedStepIndex != 3) || (step1.service_type_id ==2 && selectedStepIndex != 3) || (step1.service_type_id ==3 && selectedStepIndex != 3))" 
          (click)="saveAsDraft()">Save As Draft</button>
        <button mat-button mat-dialog-close
        class="vista-dialogbtn"
         *ngIf="!((step1.service_type_id ==1 && selectedStepIndex != 3) || (step1.service_type_id ==2 && selectedStepIndex != 3) || (step1.service_type_id ==3 && selectedStepIndex != 3))" 
         (click)="submit()">Submit</button>
        </div>
    </mat-dialog-actions>

</div>